import { Component } from '@angular/core';

import { AnchorDirective, CurrencyPipe } from '@frontend/vanilla/core';
import { TranslateModule } from '@ngx-translate/core';

import { MessageType } from '../../../../model/message.model';
import { OptionListService } from '../../../../service/optionList.service';
import { MessageComponent } from '../../../../shared/components/messages/message-component';

@Component({
    selector: 'app-rev-notification',
    templateUrl: 'reversal-notification.component.html',
    standalone: true,
    imports: [MessageComponent, TranslateModule, CurrencyPipe, AnchorDirective],
})
export class ReversalNotificationComponent {
    reversalArr: any[];
    reversalExists: boolean;

    constructor(private optionListService: OptionListService) {
        this.reversalArr = optionListService?.reversalArr;
        this.reversalExists = this.optionListService?.reversalExists;
    }

    public get messageType(): typeof MessageType {
        return MessageType;
    }

    gotoWithdrawal() {
        this.optionListService.redirectToMainCashier('&type=reverse-withdrawal');
    }

    getSumOfAllReversals() {
        let sum = 0;
        this.reversalArr.map((item) => {
            sum = sum + parseFloat(item?.redeemAmount?.value);
        });
        return +sum.toFixed(2);
    }
}
